module.exports = {
  login: {
    title: 'Sign In',
    subTitle: "Don't have an account?",
    goSignUp: 'Sign Up',
    Email: 'Email Address',
    password: 'Password',
    goForget: 'Forgot your password?',
    signUpRule: 'By continuing, you agree to our',
    TermsConditions: 'Terms & Conditions',
    PrivacyPolicy: 'Privacy Policy',
    ShippingPolicy: 'Shipping Policy',
    our: 'our',
    and: 'and',
    or: 'or',
    SignFacebook: 'Sign in with Facebook',
    bindingEmail: `If you register your facebook account through your mobile phone, you
    need to manually fill in an email address additionally, so that you
    can check the progress of your order and delivery, etc.`,
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    giveawayTitle: 'Giveaway Member',
    giveawaySubTitle: 'Not a Giveaway Member yet?'
  },
  register: {
    title: 'Sign Up',
    subTitle: 'Already have an account?',
    goSignIn: 'Sign In',
    firstName: 'First Name',
    lastName: 'Last Name',
    Email: 'Email Address',
    password: 'Password',
    inviteCode: 'Invite code (optional)',
    enterpriseSuccess: 'Congratulations! You have passed the review and Become a Gizmogo partner!',
    oAffiliate: 'Ordinary Affiliate',
    eAffiliate: 'Gizmogo Partner',
    eName: 'Enterprise Name',
    eType: 'The Enterprise Type',
    eType1: 'Phone repair store',
    eType2: 'Mobile phone store',
    eType3: 'Recycling store',
    eType4: 'Restaurant',
    eType5: 'Environmental Association',
    eType6: 'others',
    TCOFEA: 'Terms & Conditions of Gizmogo Partner',
    errorEin: 'Please enter the correct EIN',
    goEnterpriseText1: 'Selling for your business?',
    goEnterpriseText2: 'Create a free business account',
    giveawaySubTitle: 'Already a Giveaway Member?'
  },
  forget: {
    title: 'Reset Password',
    subTitle: 'Enter the email address associated with your gizmogo account.',
    subTitle2: 'Continue to Sign In?',
    clickHere: 'Click here.',
    Email: 'Email Address',
    Send: 'Get Code',
    annotation: 'The verification code is valid for 30 minutes.',
    code: 'Verification Code',
    ConfirmPassword: 'Confirm New Password',
    password: 'Password',
    Submit: 'Submit',
    sendCodeTitle: 'Check your email',
    sendCodeText: "If you can't find our message,<br/>it might be in your spam/junk",
    personInvitationCodeTitle1: 'The role of the invitation code?',
    personInvitationCodeTitle2: 'How to get the invitation code?',
    personInvitationCodeText1: `When you're a general user, you can use your invitation code to invite friends and place orders,after completing transaction, you can earn $ 10 referral rewards.`,
    personInvitationCodeText2: `If you have a friend who has already registered on the Gizmogo platform, then you can get an invitation code from your friend.<br />If none of your friends have an invitation code,then you can choose not to fill in the invitation code.`,
    enterpriseInvitationCodeTitle: 'How to get the invitation code?',
    enterpriseInvitationCodeText: `If you are recommended by a Gizmogo salesperson to register, then you can get an invitation code from the salesperson.<br />If you do not have an invitation code for a salesperson, then you can choose not to fill in the invitation code.`,
    giveawaySubTitle: 'Continue to Sign In?'
  },
  validate: {
    email: 'Please Enter Your Correct E-mail Address',
    password: 'The password format should contain at least 8-20 digits and uppercase and lowercase letters',
    FBEmail: 'Please enter the correct email address!',
    firstName: 'Please enter First Name',
    lastName: 'Please enter Last Name',
    code: 'Please Enter Your Verification Code',
    differPassword: 'The two passwords differ',
    phone: 'Please enter the correct contact information',
    samePassword: 'The old and new passwords cannot be the same',
    againPassword: 'Please enter new password again'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-us/auth.js